/**
 * Created by 1 on 2017/9/13.
 * 渲染工具类
 */
'use strict';
define([
    './CommonUtil',
    './GeometryUtil',
    '../g2'
], function(
    CommonUtil,
    GeometryUtil,
    g2
) {
    /**
     * @namespace
     * @description 渲染工具类
     *@alias G.utils.RenderUtil
     */
    var util = {};
    /**
     * 符号转图片html字符串
     * @method
     * @param symbol {Object} - 必填，符号对象g2.sfs.Symbol
     * @param options {Object} - 可选，指定的符号样式，如果指定，则覆盖symbol里的配置；
     * @returns {String} - 符号的html字符串
     * @example
     * var options= {
     *       "width": 2,
     *       "color": {
     *           "r": 255,
     *           "g": 0,
     *           "b": 0,
     *           "a": 153
     *       },
     *       "style": 5
     *   }
     * var symbol=G.utils.RenderUtil.object2Symbol('SimpleLineSymbol',options);
     * var html=G.utils.RenderUtil.symbol2ImageHtml(symbol);
     */
    util.symbol2ImageHtml = function(symbol, options) {
        var html;
        options = options || {};
        var selfObj = this;
        //images base64
        var symbolType = symbol.$type.split(',')[0];
        var getSymbolHtml = {
            'PictureMarkerSymbol': function() {
                if (symbol.source.indexOf("data:image/png;base64,") > -1) {
                    var source = symbol.source;
                } else {
                    var source = 'data:image/png;base64,' + symbol.source;
                }
                console.log(symbol.source);
                console.log(source);
                console.log("============================");
                html = '<img src="' + source + '" alt="">';
                return html;
            },
            'SimpleMarkerSymbol': function() {
                var r = symbol.size;
                r = r > 10 ? 10 : r;
                if (!isNaN(options.size)) {
                    r = options.size;
                }
                html = '<svg width="25px" height="25px" version="1.0.0">';
                html += '<circle';
                html += ' cx="' + 12 + '" ';
                html += ' cy="' + 12 + '" ';
                html += ' r="' + r + '" ';
                html += ' stroke="' + _getSvgColor(symbol.borderColor) + '" ';
                html += ' stroke-opacity="' + (symbol.borderColor.a / 255) + '" ';
                html += ' stroke-width="' + symbol.borderThickness + '" ';
                html += ' fill="' + _getSvgColor(symbol.fillColor) + '"';
                html += ' fill-opacity="' + (symbol.fillColor.a / 255) + '" ';
                html += '></svg>';
                return html;
            },
            'SimpleLineSymbol': function() {
                html = '<svg width="30px" height="20px" version="1.0.0">';
                html += '<line';
                html += ' x1="' + 5 + '" y1="' + 10 + '"';
                html += ' x2="' + 25 + '" y2="' + 10 + '"';
                html += ' stroke="' + _getSvgColor(symbol.color) + '" ';
                var strokeStyle = parseInt(symbol.style);
                if (!(strokeStyle == 1 || strokeStyle == 5)) {
                    html += ' stroke-dasharray="5,5"';
                }
                html += ' stroke-opacity="' + (symbol.color.a / 255) + '" ';
                html += ' stroke-width="' + symbol.width + '" ';
                html += '></svg>';
                return html;
            },
            'SimpleFillSymbol': function() {
                var ptStr = '0,0,0,20,25,20,25,0';
                html = '<svg width="30px" height="20px" version="1.0.0">';
                html += '<polygon';
                html += ' points="' + ptStr + '" ';
                html += ' stroke="' + _getSvgColor(symbol.borderColor) + '" ';
                html += ' stroke-opacity="' + (symbol.borderColor.a / 255) + '" ';
                html += ' stroke-width="' + symbol.borderThickness + '" ';
                html += ' fill="' + _getSvgColor(symbol.fillColor) + '"';
                html += ' fill-opacity="' + (symbol.fillColor.a / 255) + '" ';
                html += '></svg>';
                return html;
            },
            'CurrencySymbol': function() {
                var sym = symbol.markerSymbol || symbol.fillSymbol;
                html = selfObj.symbol2ImageHtml(sym);
                var textSym = symbol.textSymbol;
                if (textSym) {
                    html += '<span style="';
                    html += 'position: relative;';
                    html += 'left: -20px;';
                    html += 'top: -8px;';
                    html += 'font-size: 10px;';
                    var textColor = '#fff';
                    if (textSym.foreground) {
                        textColor = textSym.foreground.toHex().substr(0, 7);
                    }
                    html += 'color:' + textColor + ';';
                    if (textSym.fontFamilyName) {
                        html += 'font-family:' + textSym.fontFamilyName + ';';
                    }
                    if (textSym.fontWeight) {
                        html += 'font-weight:' + textSym.fontWeight + ';';
                    }
                    html += '">10</span>';
                    return html;
                }
            }
        };

        if (symbol && symbol.$type == 'pixelcluster') { //像素聚合符号
            var width = symbol.fillStrokeWidth || 10;
            var markerSym = new g2.sfs.SimpleMarkerSymbol({
                "borderColor": symbol.fillStrokeColor,
                "fillColor": symbol.fillColor,
                "borderThickness": width / 2,
                "size": width
            });
            html = markerSym2svg(markerSym, 12, 7);
            // html= this.symbol2ImageHtml(markerSym);
            html += '<span style="';
            html += 'position: relative;';
            html += 'left: -16px;';
            html += 'top: -8px;';
            html += 'font-size: 10px;';
            var textColor = '#fff';
            if (symbol.textFillColor) {
                textColor = symbol.textFillColor.toHex().substr(0, 7);
            }
            html += 'color:' + textColor + ';';
            html += '">1</span>';
        } else {
            if (typeof getSymbolHtml[symbolType] === "function") {
                html = getSymbolHtml[symbolType]();
            }
        }
        return html;
        /***
         *
         * @param color
         * @returns {string}
         * @private
         */
        function _getSvgColor(color) {
            if (color) {
                return 'rgb(' + color.r + ',' + color.g + ',' + color.b + ')';
            }
        }

        //
        function markerSym2svg(symbol, maxR, minR) {
            var thickness = isNaN(symbol.borderThickness) ? 0 : symbol.borderThickness,
                r = symbol.size,
                R = r + thickness,
                scale = 1,
                maxR = isNaN(maxR) ? 12 : maxR,
                minR = isNaN(minR) ? 5 : minR;
            if (R > maxR) {
                R = maxR;
                scale = maxR / R;
            }
            r *= scale;
            thickness *= scale;
            //
            if (r > minR) {
                thickness += (r - minR);
                r = minR;
            }
            if (!isNaN(options.size)) {
                r = options.size;
            }
            var coor = maxR;
            var html = '<svg width="25px" height="25px" version="1.0.0">';
            //
            html += '<circle';
            html += ' cx="' + coor + '" ';
            html += ' cy="' + coor + '" ';
            html += ' r="' + r + '" ';
            html += ' fill="rgb(255,255,255)"';
            html += ' fill-opacity="0" ';
            html += ' stroke="' + _getSvgColor(symbol.borderColor) + '"';
            html += ' stroke-width="' + thickness + '" ';
            html += ' stroke-opacity="' + (symbol.borderColor.a / 255) + '" />';
            //
            html += '<circle';
            html += ' cx="' + coor + '" ';
            html += ' cy="' + coor + '" ';
            html += ' r="' + r + '" ';
            html += ' fill="' + _getSvgColor(symbol.fillColor) + '"';
            html += ' fill-opacity="' + (symbol.fillColor.a / 255) + '"/>';
            html += '</svg>';
            return html;
        }
    }

    /**
     * 符号json格式转换为tsgis符号对象
     * @method
     * @param symbolObj {Object} 必填，符号对象
     * @returns {g2.sfs.Symbol}
     * @example
     * var options= {
     *       "width": 2,
     *       "color": {
     *           "r": 255,
     *           "g": 0,
     *           "b": 0,
     *           "a": 153
     *       },
     *       "style": 5
     *   }
     * var symbol=G.utils.RenderUtil.object2Symbol('SimpleLineSymbol',options);
     */
    util.object2Symbol = function(symbolObj) {
        if (arguments.length == 0) {
            throw (new Error('参数错误！'));
        }
        if (arguments.length == 1) {
            var symbolObj = arguments[0];
            if (CommonUtil.isString(symbolObj)) {
                try {
                    symbolObj = JSON.parse(symbolObj);
                } catch (e) {}
            }
            return util.object2Symbol(symbolObj.type, symbolObj.options);
        }
        var type = arguments[0],
            options = arguments[1];
        var transformers = {};
        transformers.TextSymbol = function(opts) {
            var symbol = null;
            // TODO 等三维的textSymbol支持背景色后 再放开
            var colorFields = [];
            // colorFields = ['foreground', 'borderColor', 'textBackgroundBorderColor', 'textBackgroundColor'];
            colorFields = ['foreground', 'borderColor'];
            // }
            handleColor(opts, colorFields);
            symbol = new g2.sfs.TextSymbol(opts);
            return symbol;
        }
        transformers.PictureMarkerSymbol = function(opts) {
            var source = opts.source || '',
                //配置的base64码的key值
                sourceKey = opts.sourceKey || '';
            sourceKey = sourceKey.trim();
            //提供默认值
            opts.width = isNaN(opts.width) ? 20 : opts.width;
            opts.height = isNaN(opts.height) ? 20 : opts.height;
            opts.offsetX = isNaN(opts.offsetX) ? opts.width / 2 : opts.offsetX;
            opts.offsetY = isNaN(opts.offsetY) ? opts.height / 2 : opts.offsetY;
            //source
            if (sourceKey && (!source)) {
                if (sourceKey.indexOf('.') < 0) {
                    //暂时保留使用全局变量获取，后续调整
                    opts.source = window[sourceKey] || G.icons[sourceKey];
                } else {
                    opts.source = CommonUtil.getValByVarPath(sourceKey);
                }
            }
            var symbol = new g2.sfs.PictureMarkerSymbol(opts);
            return symbol;
        }
        transformers.VectorMarkerSymbol = function (opts) {
            //TODO 未提供默认值
            let symbol = new g2.sfs.VectorMarkerSymbol(opts);
            return symbol;
        }
        transformers.SimpleMarkerSymbol = function(opts) {
            //提供默认值
            opts.size = isNaN(opts.size) ? 5 : opts.size;
            opts.offsetX = isNaN(opts.offsetX) ? opts.size / 2 : opts.offsetX;
            opts.offsetY = isNaN(opts.offsetY) ? opts.size / 2 : opts.offsetY;
            handleColor(opts, ['borderColor', 'fillColor']);
            var symbol = new g2.sfs.SimpleMarkerSymbol(opts);
            return symbol;
        }
        transformers.SimpleLineSymbol = function(opts) {
            var symbol = null;
            handleColor(opts, ['color']);
            symbol = new g2.sfs.SimpleLineSymbol(opts);
            return symbol;
        }
        transformers.SimpleFillSymbol = function(opts) {
                var symbol = null;
                handleColor(opts, ['borderColor', 'fillColor']);
                symbol = new g2.sfs.SimpleFillSymbol(opts);
                return symbol;
            }
            //项目上使用最多的是PictureMarkerSymbol，因此默认类型为图标符号
        var transformer = transformers[type || 'PictureMarkerSymbol'];
        var symbol = null;
        if (CommonUtil.isFunction(transformer)) {
            //深度拷贝参数
            var opts = jQuery.extend(true, {}, options);
            symbol = transformer(opts);
        } else {
            throw (new Error('type值错误！'));
        }
        return symbol;
        //
        function handleColor(obj, keyArr) {
            obj = obj || {};
            keyArr = keyArr || [];
            for (var i = 0, len = keyArr.length; i < len; i++) {
                var key = keyArr[i];
                if (obj[key]) {
                    obj[key] = util._getColor(obj[key]);
                }
            }
        }
    }

    /**
     * tsgis符号对象转换为符号json格式
     * @method
     * @param symbol -必填
     * @returns {Object}
     * @example
     * var options= {
     *       "width": 2,
     *       "color": {
     *           "r": 255,
     *           "g": 0,
     *           "b": 0,
     *           "a": 153
     *       },
     *       "style": 5
     *   }
     * var symbol=G.utils.RenderUtil.object2Symbol('SimpleLineSymbol',options);
     * var symbolObj=G.utils.RenderUtil.symbol2Object(symbol);
     */
    util.symbol2Object = function(symbol) {
        var type = null;
        if (symbol && symbol.$type) {
            var $type = symbol.$type;
            var regex = /^(.*Symbol),http\:\/\/www.Gs.com$/;
            if (regex.test($type)) {
                type = regex.exec($type)[1];
            }
        }
        if (!type) {
            throw (new Error('参数类型错误！'));
        }
        var obj = JSON.parse(JSON.stringify(symbol));
        delete obj['$type'];
        handleColor(obj);
        //
        var typeObj = {
            TextSymbol: 'TextSymbol',
            SimpleMarkerSymbol: 'SimpleMarkerSymbol',
            PictureMarkerSymbol: 'PictureMarkerSymbol',
            VectorMarkerSymbol: 'VectorMarkerSymbol',
            SimpleLineSymbol: 'SimpleLineSymbol',
            SimpleFillSymbol: 'SimpleFillSymbol'
        }
        return {
            type: typeObj[type],
            options: obj
        };

        function handleColor(obj) {
            var keys = ['color', 'borderColor', 'fillColor', 'foreground'];
            for (var i = 0, len = keys.length; i < len; i++) {
                var key = keys[i];
                var colorObj = obj[key];
                if (CommonUtil.isObject(colorObj)) {
                    obj[key] = util.color2Object(colorObj);
                }
            }
        }
    }

    /**
     * 颜色对象转tsgis颜色
     * @method
     * @param obj {Object}
     * @param obj.a {Number} 0-255
     * @param obj.r {Number} 0-255
     * @param obj.g {Number} 0-255
     * @param obj.b {Number} 0-255
     * @returns {Object} -g2.sfs.Color
     */
    util.object2Color = function(obj) {
        return util._getColor(obj);
    }

    /**
     * 颜色转对象
     * @method
     * @param color {String/g2.sfs.Color} 必填，颜色，tsgis颜色类型或者 '#fff'字符串
     * @returns {Object} 颜色对象
     */
    util.color2Object = function(color) {
        var obj = {};
        if (CommonUtil.isString(color)) {
            try {
                color = g2.sfs.Color.fromHex(color);
            } catch (e) {}
        }
        if (color &&
            color.$type == 'Color,http://www.Gs.com') {
            obj['a'] = color['a'];
            obj['r'] = color['r'];
            obj['g'] = color['g'];
            obj['b'] = color['b'];
        }
        return obj;
    }

    /**
     * 根据配置获取颜色
     * @method
     * @param obj
     * @private
     */
    util._getColor = function(obj) {
        if (CommonUtil.isObject(obj)) {
            var result = jQuery.extend(true, {}, obj);
            if (result['alpha']) {
                result['a'] = result['alpha'];
                delete result['alpha'];
            }
            return new g2.sfs.Color(result);
        } else if (typeof obj == 'string') {
            return g2.sfs.Color.fromHex(obj);
        } else {
            return obj;
        }
    }

    /**
     * 将元素渲染到地图上
     * @method
     * @param geoinfo {Object} - 必填，几何信息，可以为geoJson/wkt/g2.sfs.Geometry实例
     * @param symbol {Object} - 可选，指定的符号样式；
     * @example
     * {
     *    "type": "SimpleMarkerSymbol",
     *    "options": {
     *      "borderColor": {
     *        "a": 153,
     *        "r": 0,
     *        "g": 0,
     *        "b": 0
     *      },
     *      "fillColor": {
     *        "a": 153,
     *        "r": 65,
     *        "g": 105,
     *        "b": 225
     *      },
     *      "borderThickness": 2,
     *      "size": 10
     *    }
     * }
     * {
     *    "type": "PictureMarkerSymbol",
     *    "options": {
     *      "sourceKey":"demo.icons.ternimal_0_0",
     *      "width": 22,
     *      "height": 22,
     *      "opacity": 1,
     *      "rotation": 0,
     *      "offsetX": 11,
     *      "offsetY": 11
     *    }
     * }
     * {
     *    "type": "SimpleLineSymbol",
     *    "options": {
     *      "color": {
     *        "a": 153,
     *        "r": 0,
     *        "g": 0,
     *        "b": 255
     *      },
     *      "style": 5,
     *      "width": 2
     *    }
     * }
     * {
     *    "type": "SimpleFillSymbol",
     *    "options": {
     *      "borderColor": {
     *        "a": 153,
     *        "r": 0,
     *        "g": 0,
     *        "b": 255
     *      },
     *      "fillColor": {
     *        "a": 150,
     *        "r": 19,
     *        "g": 181,
     *        "b": 177
     *      },
     *      "borderThickness": 0,
     *      "opacity": 1
     *    }
     * }
     * {
     *    "type": "TextSymbol",
     *    "options": {
     *      "text": "文本",
     *      "fontFamilyName": "黑体",
     *      "fontSize": 18,
     *      "foreground": {
     *        "a": 255,
     *        "r": 0,
     *        "g": 0,
     *        "b": 255
     *      },
     *      "borderColor": {
     *        "a": 1,
     *        "r": 255,
     *        "g": 255,
     *        "b": 255
     *      },
     *      "borderThickness": 0,
     *      "rotation": 0,
     *      "offsetX": 0,
     *      "offsetY": 0
     *    }
     * }
     * @param eleinfo {Object} - 可选，元素信息 {id: "Sinjur", name: "轻伤区域", "layer":g2.lys.layer(可选)}}
     * @param eleinfo.id {String} 可选，元素id
     * @param eleinfo.name {String} 可选，元素名称
     * @param eleinfo.layer {Object} 可选，图层对象
     * @returns {Element/Feature} - 返回所渲染的元素
     */
    util.geoinfoToElement = function(geoinfo, symbol, eleinfo) {
        console.log(symbol);
        var Symbol;
        if (symbol.$type) {
            Symbol = symbol;
        } else {
            Symbol = util.object2Symbol(symbol.type, symbol.options);
        }
        // var Symbol = util.object2Symbol(symbol.type, symbol.options);
        console.log(Symbol);
        var GeometryFactory = g2.sfs.GeometryFactory;
        var isObject = CommonUtil.isObject(geoinfo);
        var isString = CommonUtil.isString(geoinfo);
        eleinfo = eleinfo || {};
        //随机生成id
        if (!eleinfo.hasOwnProperty('id')) {
            eleinfo.id = CommonUtil.newUUID32();
        }
        var Geometry;
        var propArr = [];
        //如果是tsgis geometry对象
        if (GeometryUtil.getG2GeometryType(geoinfo) != null) {
            Geometry = geoinfo;
        } else if (isObject) {
            /**
             * @todo  需要解析geojson中的属性信息
             */
            Geometry = GeometryFactory.createGeometryFromGeoJson(geoinfo);
        } else if (isString) {
            Geometry = GeometryFactory.createGeometryFromWkt(geoinfo);
        }
        if (Geometry) {
            if (eleinfo.layer instanceof g2.carto.FeatureLayer) {
                //返回一个feature对象不加入图层展示
                var feature = new g2.sfs.Feature({ geometry: Geometry, values: eleinfo.property });
                feature.symbol = Symbol;
                feature.id = eleinfo.id;
                feature.name = eleinfo.name;
                return feature;
            } else {
                var ModelElement = new g2.sfs.Element({
                    geometry: Geometry,
                    symbol: Symbol,
                    id: eleinfo.id,
                    name: eleinfo.name
                });
                var attArr = eleinfo.property;
                var obj = new g2.sfs.Attribute({
                    name: 'data',
                    value: attArr
                });
                propArr.push(obj);
                ModelElement.attributeSet.attributes = propArr;
                if (eleinfo.layer) {
                    eleinfo.layer.add(ModelElement);
                }
                return ModelElement;
            }
        } else {
            throw (new Error('geoinfo格式错误！'));
        }
    }
    return util;
});